// extracted by mini-css-extract-plugin
export default {"errorContainer":"Error_errorContainer__prrD2","errorSection":"Error_errorSection__ao88l","backHomeBtn":"Error_backHomeBtn__YNLqm"};